<template lang="pug">
  //- Barra de filtros de búsqueda
  .b2b-filters
    b2b-search-bar
      div.block(slot='header')
        span.dateHeader {{ $t('pendingtask.filters.creation_date.value') }}
        ods-date-picker(
          v-model='dateTimePickerValue',
          type='datetimerange',
          :picker-options='pickerOptions2',
          @change='getDateTimePickerValue',
          :range-separator='$t("msg_generics.datepicker.separator")',
          :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
          :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
          :format='$t("date_format_long_datepicker")',
          :canSelectSeconds='true',
          :clearable='false',
          clearIcon='',
          :default-time="['00:00:00', '23:59:59']",
          prefix-icon='prefix-icon-date-time-picker',
          :showFooterButtons='true',
          align='right')
        ods-tooltip.ods-ml-4(:content='$t("buttons.refresh_tooltip")', placement='bottom')
          ods-button(
            icon='ods-icon-refresh',
            size='medium',
            circle,
            @click="activeRefreshResults")
      div(slot='body')
        ods-form.b2b-filters__area(
          :model='filterForm',
          :rules='rules',
          ref='filterForm',
          @submit.native.prevent='')
          ods-form-item.first-input(prop='firstValue')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='filterForm.firstValue',
              :placeholder='$t("msg_generics.advanced_search")',
              @change='getFirstValue')

              ods-option(
                v-for='option in options',
                :key='option.col',
                :label='$t(option.value)',
                :disabled='option.selected',
                :value='option')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              //- Select type
              div(v-if="(selected.componente === 'select' && selected.prop !== 'statusId' && selected.prop !== 'statusInternalId' && selected.prop !== 'buyerId')")
                ods-form-item.others-input(prop='secondValueSelect')
                  ods-select(v-if="selected.prop === 'projectId'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='option.name',
                      :value='option.id')
                  ods-select(v-if="selected.prop === 'taxTypeCode'  || selected.prop === 'invoiceTypeId' || selected.prop === 'receptionMethodId' ",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='formatterLabel(option.code)',
                      :value='option.id')
                  ods-select(v-if="selected.prop === 'buyerId'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :filter-method='filterPartiesBuyer',
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                        v-for='option in selected.options',
                        :key='option.id',
                        :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                        :value='option.id')
                  ods-select(v-if="selected.prop === 'sellerId'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :filter-method='filterPartiesSeller',
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                      :value='option.id')
                  ods-select(v-if="selected.prop === 'pendingTask'  || selected.prop === 'withAttachment' ",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                        v-for='option in selected.options',
                        :key='option.id',
                        :label='$t("msg_generics.question." + option.type)',
                        :value='option.id')
                  ods-select(v-else-if="selected.prop === 'currencyId'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='$t("currency." + option.code)',
                      :value='option.id')
                  ods-select(v-else-if="selected.prop === 'documentClassCode'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='(option, index) in selected.options',
                      :key='index',
                      :label='$t("document_class." + option)',
                      :value='option')

              div(v-else-if="(selected.componente === 'select' && selected.prop === 'statusId' || selected.prop === 'statusInternalId')")
                ods-form-item.others-input(prop='secondValueSelectMultiple')
                  ods-select(v-if="selected.prop === 'statusInternalId'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelectMultiple',
                    filterable
                    multiple,
                    collapse-tags,
                   :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='$t("invoice_status." + option.code)',
                      :value='option.id')
                  ods-select(v-if="selected.prop === 'statusId'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelectMultiple',
                    filterable
                    multiple,
                    collapse-tags,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='$t("invoice_status." + option.code)',
                      :value='option.id')
              //-Exclusivo buyerID
              div(v-else-if="(selected.componente === 'select' && selected.prop === 'buyerId')")
                ods-form-item.others-input(prop='secondValueSelect')
                  div(v-if="(userLoggedOneProjectOneParty || userLoggedOneProjectOnePartyOneCentre)")
                    ods-tooltip( placement="top")
                      template(slot='content')
                        | {{this.optionsFilterBuyerPendingTask[0].tradeName}}
                      ods-select(
                        :no-match-text='$t("msg_generics.no_match")',
                        v-model='filterForm.secondValueSelect',
                        :placeholder='$t(selected.placeholder)',
                        :disabled='true')
                        ods-option(
                          v-for='option in selected.options',
                          :key='option.id',
                          :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                          :value='option.id')
                  div(v-else)
                    ods-select(
                      :no-match-text='$t("msg_generics.no_match")',
                      v-model='filterForm.secondValueSelect',
                      filterable,
                      :filter-method='filterPartiesBuyer',
                      :placeholder='$t(selected.placeholder)',
                      @change='getSecondValue')
                      ods-option(
                          v-for='option in selected.options',
                          :key='option.id',
                          :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                          :value='option.id')
              //- INVOICE NUMBER
              div(v-else-if="selected.componente === 'input' && (selected.prop === 'invoiceNumber')")
                ods-form-item.others-input(prop='invoiceNumber')
                      ods-input(
                          :placeholder='$t(selected.placeholder)',
                          v-model.trim='filterForm.invoiceNumber',
                          @input='getSecondValue')
              //- REGISTER NUMBER
              div(v-else-if="selected.componente === 'input' && (selected.prop === 'registerNumber')")
                ods-form-item.others-input(prop='registerNumber')
                      ods-input(
                          :placeholder='$t(selected.placeholder)',
                          v-model='filterForm.registerNumber',
                          @input='getSecondValue')
              //- SERIES CODE
              div(v-else-if="selected.componente === 'input' && (selected.prop === 'invoiceSeriesCode')")
                ods-form-item.others-input(prop='invoiceSeriesCode')
                      ods-input(
                          :placeholder='$t(selected.placeholder)',
                          v-model='filterForm.invoiceSeriesCode',
                          @input='getSecondValue')
              //- CORRECTIVE
              div(v-else-if="selected.componente === 'input' && (selected.prop === 'correctiveInvoiceNumber')")
                ods-form-item.others-input(prop='correctiveInvoiceNumber')
                      ods-input(
                          :placeholder='$t(selected.placeholder)',
                          v-model.trim='filterForm.correctiveInvoiceNumber',
                          @input='getSecondValue')
              //- TASAS
              div(v-else-if="selected.componente === 'input' && (selected.prop === 'rate')")
                ods-form-item.others-input(prop='rate')
                      ods-input(
                          :placeholder='$t(selected.placeholder)',
                          v-model='filterForm.rate',
                          @input='getSecondValue')
              //- Input type String
              div(v-else-if="selected.componente === 'input' && selected.tipo === 'string' && (selected.prop !== 'correctiveInvoiceNumber' || selected.prop !== 'rate' || selected.prop !== 'invoiceSeriesCode' || selected.prop === 'registerNumber')")
                ods-form-item.others-input(prop='secondValue')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model='filterForm.secondValue',
                    @input='getSecondValue')
              //- Date Type
              div(v-else-if="selected.componente === 'date'")
                ods-form-item(prop='filterDatePickerValue')
                  ods-date-picker(
                    v-model='filterForm.filterDatePickerValue',
                    type='daterange',
                    :picker-options='pickerOptions2',
                    @change='getDateRangePickerValue',
                    :range-separator='$t("msg_generics.datepicker.separator")',
                    :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
                    :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
                    :format='$t("date_format_calendar")',
                    prefix-icon='prefix-icon-date-time-picker',
                    align='right')
              //- Importes
              div(v-else-if="selected.tipo === 'number' && (selected.prop === 'totalExecutableAmountTo' || selected.prop === 'totalExecutableAmountFrom')")
                ods-form-item(prop='secondValueDecimal')
                  ods-input.others-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model='filterForm.secondValueDecimal',
                    @input='getSecondValue')
              div(v-else)
                ods-form-item.others-input(prop='secondValueNumber')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model='filterForm.secondValueNumber',
                    @input='getSecondValue')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show="(selected.prop === 'buyerId' || selected.prop === 'sellerId') && filterForm.secondValueSelect")
              ods-form-item.others-input(prop='thirdValueSelect')
                ods-select(
                  v-if="(selected.prop === 'sellerId')"
                  :no-match-text='$t("msg_generics.no_match")',
                  v-model='filterForm.thirdValueSelect',
                  multiple,
                  filterable,
                  collapse-tags,
                  :placeholder='selectedCentre.placeholder',
                  @change='getThirdValue')
                  ods-option(
                    v-for='option in selectedCentre.options',
                    :key='option.id',
                    :label='option.code',
                    :value='option.id')
                ods-select(
                    v-if="(!this.userLoggedOneProjectOnePartyOneCentre && selected.prop === 'buyerId')"
                  :no-match-text='$t("msg_generics.no_match")',
                  v-model='filterForm.thirdValueSelect',
                  multiple,
                  filterable,
                  collapse-tags,
                  :placeholder='selectedCentre.placeholder',
                  @change='getThirdValue')
                  ods-option(
                    v-for='option in selectedCentre.options',
                    :key='option.id',
                    :label='option.code',
                    :value='option.id')
                ods-tooltip(
                  v-if="(this.userLoggedOneProjectOnePartyOneCentre && selected.prop === 'buyerId')"
                  placement="top")
                  template(slot='content')
                    | {{ centreUser.code }}
                  ods-input.others-input(
                    v-model='centreUser.code',
                    :label='centreUser.code',
                    :disabled='true')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              ods-button(
                :disabled="!activeButtonAddFilter"
                icon='ods-icon-plus',
                size='medium',
                circle,
                @click.native="onSubmit('filterForm')")

    .b2b-filters__container(v-if='listSelectedFiltersPendingTask.length > 0')
      transition-group.b2b-filters__group(
        name='ods-fade-in-linear',
        tag='div')
        ods-popover(
          key='icon-delete-filters',
          placement='top-start',
          trigger='hover',
          :content='$t("msg_generics.popover_clean_filters")')
          ods-button.clean-filters(
            slot='reference',
            type='neutral',
            size='small',
            icon='ods-icon-delete'
            @click='handleDeleteAllFilters')

        .b2b-filters__button(
          v-for='(filter, index) in listSelectedFiltersPendingTask',
          :key='index')
          b2b-filter-button-pending-task(
            :filter='filter',
            @closeTag='resetSelectedOneOption')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bSearchBar from '@/components/B2bSearchBar'
import B2bFilterButtonPendingTask from './B2bFilterButtonPendingTask'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-filters-pending-task',

  props: {
    filterOptions: {
      type: Object,
      required: true
    }
  },

  mixins: [Utils],

  components: {
    B2bSearchBar,
    B2bFilterButtonPendingTask
  },

  data () {
    const _this = this
    const checkNumber = (rule, value, callback) => {
      if (!this.checkCorrectNumber(value)) {
        callback(new Error(this.$t('msg_generics.format_invalid')))
      } else if (this.countDecimals(value) > 6) {
        callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
      }
      callback()
    }
    const checkNegativeNumber = (rule, value, callback) => {
      if (!this.checkCorrectNumber(value, true)) {
        callback(new Error(this.$t('msg_generics.format_invalid')))
      } else if (this.countDecimals(value) > 6) {
        callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
      }
      callback()
    }
    const validateRate = (rule, value, callback) => {
      if (value > 1000) {
        callback(new Error(this.$t('msg_generics.max_value', { max: 1000 })))
      } else {
        callback()
      }
    }
    return {
      activeButtonAddFilter: true,
      userLoggedOneProjectOneParty: false, // Flag que nos indica si el usuario tiene 1 solo proyecto y una sola empresa
      userLoggedOneProjectOnePartyOneCentre: false, // Flag que nos indica si el usuario tiene 1  proyecto 1 empresa 1 centro
      // DatePicker
      dateTimePickerValue: [],
      pickerOptions2: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: this.$t('msg_generics.datepicker.today'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'today')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_week'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastWeek')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_month'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastMonth')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_three_months'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastThreeMonths')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastYear')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_two_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastTwoYear')
            }
          }
        ]
      },
      // Forumlario
      filterForm: {
        secondValueWithoutMin: '',
        firstValue: '',
        secondValue: '',
        filterDatePickerValue: [],
        secondValueSelect: '',
        secondValueNumber: '',
        secondValueDecimal: '',
        thirdValueSelect: [],
        invoiceNumber: '',
        registerNumber: '',
        invoiceSeriesCode: '',
        correctiveInvoiceNumber: '',
        rate: '',
        secondValueSelectMultiple: []
      },
      tid: null,
      selected: {},
      selectedCentre: {},
      selectedFilters: [],
      options: {},
      auxListPartiesBuyer: [],
      auxListPartiesSeller: [],
      centreUser: {},

      // Reglas Validación
      rules: {
        invoiceNumber: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 40, message: this.$t('msg_generics.max_num_character', { max: 40 }), trigger: 'change' }
        ],
        registerNumber: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 60, message: this.$t('msg_generics.max_num_character', { max: 60 }), trigger: 'change' }
        ],
        invoiceSeriesCode: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 20, message: this.$t('msg_generics.max_num_character', { max: 20 }), trigger: 'change' }
        ],
        correctiveInvoiceNumber: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 20, message: this.$t('msg_generics.max_num_character', { max: 20 }), trigger: 'change' }
        ],
        rate: [
          { pattern: /^[0-9]*$/, message: this.$t('msg_generics.number_required'), trigger: 'change' },
          { validator: validateRate, trigger: 'change' }
        ],
        filterDatePickerValue: [
          {
            required: true,
            message: this.$t('msg_generics.date_required'),
            trigger: 'change'
          }
        ],
        secondValueNumber: [
          { required: true, message: this.$t('msg_generics.field_required') },
          { validator: checkNumber, trigger: 'change' }
        ],
        secondValueDecimal: [
          { required: true, message: this.$t('msg_generics.field_required') },
          { validator: checkNegativeNumber, trigger: 'change' }
        ],
        secondValue: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 50, message: this.$t('msg_generics.max_num_character', { max: 50 }), trigger: 'change' }
        ],
        secondValueSelect: [
          {
            required: true,
            message: this.$t('msg_generics.element_selected'),
            trigger: 'click'
          }
        ],
        secondValueSelectMultiple: [
          {
            required: true,
            message: this.$t('msg_generics.element_selected'),
            trigger: 'click'
          }
        ],
        thirdValueSelect: [
          {
            required: this.firstValue === this.$t('pendingtask.filters.buyer.value') || this.firstValue === this.$t('pendingtask.filters.seller.value'),
            message: this.$t('msg_generics.element_selected'),
            trigger: 'change'
          }
        ]
      }
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'queryPendingTask',
      'listSelectedFiltersPendingTask',
      // Combos
      'optionsFilterService',
      'optionsFilterBuyerPendingTask',
      'optionsFilterSellerPendingTask',
      'optionsFilterCurrency',
      'optionsFilterInvoiceClasses',
      'optionsFilterInvoiceTaxType',
      'optionsFilterInvoiceType',
      'optionsFilterStatusPendingTask',
      'optionsFilterInternalStatusPendingTask',
      'optionsFilterInvoiceReceiveMethods'
    ])
  },

  watch: {
    $route (to) {
      this.listSelectedFiltersPendingTask = this.listSelectedFiltersPendingTask // eslint-disable-line
    }
  },

  methods: {
    activeRefreshResults () {
      this.refreshResults()
    },
    ...mapActions([
      'getPendingTask',
      'getOptionsService',
      'queryPendingTaskState',
      'listSelectedFiltersPendingTaskState',
      'getOptionsFilterPartyME',
      'getOptionsFilterPartyRelationCommercial',
      'getOptionsFilterStatusPendingTask',
      'getOptionsFilterStatusInternalPendingTask',
      'getOptionsFilterPartyMEFenixBackend',
      'getOptionsFilterCentresOrderByEnabledFenixBackend',
      'getCentresByParty',
      'getOptionsFilterInvoiceReceiveMethods',

      // Combos
      'optionsFilterBuyerPendingTaskState',
      'optionsFilterSellerPendingTaskState',
      'optionsFilterStatusPendingTaskState',
      'optionsServicesEnabledState',
      'optionsFilterInternalStatusPendingTaskState'
    ]),

    formatterLabel (code) {
      const type = this.selected.prop
      let key
      switch (type) {
        case 'taxTypeCode':
          key = 'tax_type.'
          break
        case 'invoiceTypeId':
          key = 'invoice_type.'
          break
        case 'receptionMethodId':
          key = 'communication_method.'
          break
      }
      return this.$t(key + code)
    },
    async getFirstValue (data) {
      this.filterForm.invoiceNumber = ''
      this.filterForm.registerNumber = ''
      this.filterForm.invoiceSeriesCode = ''
      this.filterForm.rate = ''
      this.filterForm.correctiveInvoiceNumber = ''
      this.filterForm.secondValueWithoutMin = ''
      this.filterForm.secondValue = ''
      this.filterForm.secondValueNumber = ''
      this.filterForm.secondValueDecimal = ''
      this.filterForm.secondValueSelect = ''
      this.filterForm.secondValueSelectMultiple = []
      this.filterForm.thirdValueSelect = []
      this.filterForm.filterDatePickerValue = []
      this.$refs.filterForm.clearValidate()
      this.selected = data

      await this.getPreloadParties(data.prop, this.queryPendingTask.projectId)

      // Precarga de centro y empresa en el combo de vendedores, si procede
      // Se pueden dar 3 casuísticas distintas
      // 1.Usuario con 1 proyecto y 1 empresa y centros === null
      // 2.Usuario con 1 proyecto 1 empresa y 1 centro
      // 3.El resto de casos

      // No tiene 1 solo proyecto y 1 sola empresa.
      if (!this.userLoggedOneProjectOneParty) {
        this.activeButtonAddFilter = true
      } else {
        // 1 proyecto - 1 empresa y 1 a N centros
        if (data.prop === 'buyerId') {
          this.filterForm.secondValueSelect = this.optionsFilterBuyerPendingTask[0].tradeName
          this.selected.query = this.optionsFilterBuyerPendingTask[0].id
          this.selected.labelText = this.optionsFilterBuyerPendingTask[0].tradeName
          this.selected.partyId = this.selected.labelText
          // 2.Usuario con 1 proyecto 1 empresa y un centro
          if (this.userLoggedOneProjectOnePartyOneCentre) {
            const data = {
              projectId: this.activeUser.data.projects[0].id,
              partyId: this.activeUser.data.projects[0].parties[0].id
            }
            const centroBd = await this.getCentresByParty(data)
            this.centreUser = {
              id: centroBd[0].id,
              code: centroBd[0].code + '-' + centroBd[0].name
            }
            this.selected.labelText = this.selected.partyId + ' ' + this.$t('breadcrumb.administration_project_admin_centres') + ': ' + centroBd[0].code
            this.filterForm.thirdValueSelect = this.centreUser.id
            this.activeButtonAddFilter = false
          // 1.Usuario con 1 proyecto y 1 empresa y centros === null
          } else if (this.userLoggedOneProjectOneParty) {
            const party = {
              query: this.optionsFilterBuyerPendingTask[0].id,
              prop: 'buyerId'
            }
            await this.getListCentres(party)
            this.selectedCentre = this.selected.centro_comprador
            this.activeButtonAddFilter = true
          }
        } else {
          this.activeButtonAddFilter = true
        }
      }
    },

    getSecondValue (data) {
      if (this.selected.componente === 'select') {
        if (this.selected.prop === 'projectId') {
          const option = this.selected.options.find(function (elem) {
            return elem.id === data
          })
          this.selected.query = option.id
          this.selected.labelText = option.name
        } else if (
          this.selected.componente === 'select' &&
          this.selected.prop === 'documentClassCode'
        ) {
          this.selected.query = data
          this.selected.labelText = this.$t('document_class.' + data)
        } else if (
          this.selected.componente === 'select' &&
          this.selected.prop === 'currencyId'
        ) {
          const option = this.selected.options.find(function (elem) {
            return elem.id === data
          })
          this.selected.query = option.id
          this.selected.labelText = this.$t('currency.' + option.code)
        } else if (
          this.selected.prop === 'taxTypeCode' ||
          this.selected.prop === 'invoiceTypeId' ||
          this.selected.prop === 'receptionMethodId'
        ) {
          const option = this.selected.options.find(function (elem) {
            return elem.id === data
          })
          this.selected.query = option.id
          this.selected.labelText = this.formatterLabel(option.code)
        } else if (this.selected.prop === 'statusId' || this.selected.prop === 'statusInternalId') {
          const self = this
          let description = ''
          const estados = this.selected.options

          for (let index = 0; index < data.length; index++) {
            const element = data[index]
            estados.find(function (elem) { // eslint-disable-line
              if (elem.id === element) {
                description += self.$t('invoice_status.' + elem.code)
                if (index < data.length - 1) {
                  description += ','
                }
              }
            })
          }

          this.selected.labelText = description
        } else if (
          this.selected.prop === 'pendingTask' ||
          this.selected.prop === 'withAttachment'
        ) {
          const option = this.selected.options.find(function (elem) {
            return elem.id === data
          })
          this.selected.query = option.value
          this.selected.labelText = this.$t('msg_generics.question.' + option.type)
        } else if (
          this.selected.prop === 'buyerId' ||
          this.selected.prop === 'sellerId'
        ) {
          const option = this.selected.options.find(function (elem) {
            return elem.id === data
          })
          this.selected.query = option.id
          this.selected.labelText = option.tradeName
          this.selected.partyId = this.selected.labelText
          // Obtenemos la lista de centros asociados al componente seleccionado, ya sea comprador o vendedor
          this.getListCentres(this.selected)
          this.selectedCentre =
            this.selected.prop === 'buyerId'
              ? this.selected.centro_comprador
              : this.selected.centro_vendedor
        }
      } else if (this.selected.componente === 'input') {
        this.selected.query = data
        this.selected.labelText = data
      } else if (this.selected.componente === 'date') {
        this.selected.labelText = data.query
      }

      this.$refs.filterForm.clearValidate()
    },

    getThirdValue (data) {
      let description = ''
      const centros = this.selected.prop === 'buyerId' ? this.selected.centro_comprador.options : this.selected.centro_vendedor.options

      for (let index = 0; index < data.length; index++) {
        const element = data[index]
        centros.find(function (centro) { // eslint-disable-line
          if (centro.id === element) {
            description += centro.code
            if (index < data.length - 1) {
              description += ','
            }
          }
        })
      }
      if (description.length > 35) {
        let shorterTag = description.slice(0, 35)
        shorterTag = shorterTag.slice(0, shorterTag.lastIndexOf(','))
        this.selected.labelText = this.selected.partyId + ' ' + this.$t('breadcrumb.administration_project_admin_centres') + ': ' + shorterTag + '...'
      } else {
        this.selected.labelText = this.selected.partyId + ' ' + this.$t('breadcrumb.administration_project_admin_centres') + ': ' + description
      }
    },

    // Precargamos los combos de vendedor y comprador cuando el resultado sea menor de 50,
    // El de comprador para el caso en que no sea un usuario unica empresa (ya que para este caso se precargará con la unica empresa) y si es superadministrador se debe haber seleccionado el proyecto
    // El vendedor para el caso que no sea superadministrador o se haya seleccionado el proyecto
    async getPreloadParties (propSelected, projectId) {
      if (propSelected === 'buyerId') {
        if (((this.activeUser.data.isSuperAdmin && projectId) || (!this.activeUser.data.isSuperAdmin && !this.userLoggedOneProjectOneParty))) {
          const dataQueryBuyer = {
            role: 'BUYER',
            emission: false,
            seller: false,
            page: 0,
            size: 55,
            projectId: projectId,
            enable: true
          }
          const compradores = await this.getOptionsFilterPartyMEFenixBackend(dataQueryBuyer)
          await this.optionsFilterBuyerPendingTaskState(compradores)
          if (compradores.length < 51) {
            this.selected.options = compradores
            if (compradores.length === 1) {
              this.queryPendingTask.buyerId = compradores[0].id
            }
          } else {
            this.optionsFilterBuyerPendingTaskState([])
          }
        } else {
          if (!this.userLoggedOneProjectOneParty) {
            this.optionsFilterBuyerPendingTaskState([])
          }
        }
      }

      if (propSelected === 'sellerId') {
        if (((this.activeUser.data.isSuperAdmin && projectId) || (!this.activeUser.data.isSuperAdmin))) {
          const dataQuerySeller = {
            role: 'SELLER',
            emission: false,
            seller: true,
            page: 0,
            size: 55,
            projectId: projectId,
            enable: true
          }
          const vendedores = await this.getOptionsFilterPartyMEFenixBackend(dataQuerySeller)
          await this.optionsFilterSellerPendingTaskState(vendedores)
          if (vendedores.length < 51) {
            this.selected.options = vendedores
            if (vendedores.length === 1) {
              this.queryPendingTask.sellerId = vendedores[0].id
            }
          } else {
            this.optionsFilterSellerPendingTaskState([])
          }
        } else {
          this.optionsFilterSellerPendingTaskState([])
        }
      }
    },

    // Metodo auxiliar para obtener la lista de centros asociados a unna empresa,
    // ya sea compradora o vendedora
    async getListCentres (party) {
      const load = this.$loading({
        lock: true
      })
      const dataQuery = {
        idProject: this.queryPendingTask.projectId,
        idParty: party.query,
        isBuyer: null,
        isSeller: null,
        isEnable: null,
        roles: null
      }
      try {
        if (party.prop === 'buyerId') {
          if (this.userLoggedOneProjectOneParty && this.activeUser.data.projects[0].parties[0].buyer) {
            this.selected.labelText = this.optionsFilterBuyerPendingTask[0].tradeName
          }
          dataQuery.isBuyer = true
          this.options.comprador.centro_comprador.options = await this.getOptionsFilterCentresOrderByEnabledFenixBackend(dataQuery)
        } else {
          dataQuery.isSeller = true
          this.options.vendedor.centro_vendedor.options = await this.getOptionsFilterCentresOrderByEnabledFenixBackend(dataQuery)
        }
      } catch (error) {
        console.log('getListCentres CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Metodo que nos indica el numero de proyectos-empresas y centros de un usuario
    getProjectPartiesCentres () {
      let numParties = 0
      let numProject = 0
      let numCentres = 0
      if (this.activeUser.data && this.activeUser.data.projects) {
        numProject = this.activeUser.data.projects.length
      }
      // Si el usuario logeado pertenece a un solo proyecto
      if (numProject === 1) {
        if (this.activeUser.data.projects[0].parties) {
          numParties = this.activeUser.data.projects[0].parties.length
        }
        // Si tiene una sola empresa
        if (numParties === 1) {
          const comprador = {
            id: this.activeUser.data.projects[0].parties[0].id,
            tradeName: this.activeUser.data.projects[0].parties[0].name
          }
          // seteamos la empresa en el campo comprador
          const lstBuyer = []
          lstBuyer.push(comprador)
          this.optionsFilterBuyerPendingTaskState(lstBuyer)
          // Activamos a true
          this.userLoggedOneProjectOneParty = true

          // Si tiene un solo proyecto-centro y empresa
          if (this.activeUser.data.projects[0].parties[0].centres) {
            numCentres = this.activeUser.data.projects[0].parties[0].centres.length
            if (numCentres === 1) {
              // Activamos a true
              this.userLoggedOneProjectOnePartyOneCentre = true
            }
          }
        }
      }
    },
    // Filtro Fechas Emision
    getDateRangePickerValue () {
      console.log('FILTRO SELECCIONADO ', this.selected)
      this.selected.query = this.filterForm.filterDatePickerValue
      this.getSecondValue(this.selected)
    },

    onSubmit (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const dataQuery = {
            query: {}
          }
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.filter_selected')
          })
          try {
            console.log('1 Filtro Seleccionado: ', this.selected)
            const column = this.selected.prop
            switch (column) {
              case 'projectId':
                this.queryPendingTask.projectId = this.selected.query
                // Si el usuario tiene mas de un servicio,buscamos los estados del proyecto seleccionado
                if (this.optionsFilterService.length > 1) {
                  this.changeStatus(this.selected.query)
                }
                break
              case 'buyerId':
                this.queryPendingTask.buyerId = this.selected.query
                this.queryPendingTask.buyerGenericCentreId = this.filterForm.thirdValueSelect
                break
              case 'sellerId':
                this.queryPendingTask.sellerId = this.selected.query
                this.queryPendingTask.sellerCentreId = this.filterForm.thirdValueSelect
                break
              case 'invoiceNumber':
                this.queryPendingTask.invoiceNumber = this.selected.query.trim()
                break
              case 'invoiceSeriesCode':
                this.queryPendingTask.invoiceSeriesCode = this.selected.query.trim()
                break
              case 'correctiveInvoiceNumber':
                this.queryPendingTask.correctiveInvoiceNumber = this.selected.query.trim()
                break
              case 'totalExecutableAmountFrom':
                this.selected.query = this.selected.query.replace(',', '.')
                this.queryPendingTask.totalExecutableAmountFrom = this.selected.query
                break
              case 'totalExecutableAmountTo':
                this.selected.query = this.selected.query.replace(',', '.')
                this.queryPendingTask.totalExecutableAmountTo = this.selected.query
                break
              case 'statusId':
                this.queryPendingTask.statusId = this.filterForm.secondValueSelectMultiple
                break
              case 'documentClassCode':
                this.queryPendingTask.documentClassCode = this.selected.query
                break
              case 'registerNumber':
                this.queryPendingTask.registerNumber = this.selected.query.trim()
                break
              case 'receptionMethodId':
                this.queryPendingTask.receptionMethodId = this.selected.query
                break
              case 'withAttachment':
                this.queryPendingTask.withAttachment = this.selected.query
                break
              case 'statusInternalId':
                this.queryPendingTask.statusInternalId = this.filterForm.secondValueSelectMultiple
                break
              case 'pendingTask':
                this.queryPendingTask.pendingTask = this.selected.query
                break
              case 'invoiceTypeId':
                this.queryPendingTask.invoiceTypeId = this.selected.query
                break
              case 'taxTypeCode':
                this.queryPendingTask.taxTypeCode = this.selected.query
                break
              case 'rate':
                this.queryPendingTask.rate = this.selected.query
                break
              case 'currencyId':
                this.queryPendingTask.currencyId = this.selected.query
                break
              case 'orderNumber':
                this.queryPendingTask.orderNumber = this.selected.query.trim()
                break
              case 'contract':
                this.queryPendingTask.contract = this.selected.query
                break
              case 'deliveryNote':
                this.queryPendingTask.deliveryNote = this.selected.query
                break
              case 'file':
                this.queryPendingTask.file = this.selected.query
                break
              case 'issueDates':
                this.queryPendingTask.issueDateFrom = this.selected.query[0]
                this.queryPendingTask.issueDateTo = this.selected.query[1]
                break
              case 'operationDates':
                this.queryPendingTask.operationDateFrom = this.selected.query[0]
                this.queryPendingTask.operationDateTo = this.selected.query[1]
                break
              default:
                break
            }

            // Si el usuario logeado tiene mas de un proyecto no seleccionamos servicio lanzamos error
            if (this.optionsFilterService.length > 1) {
              if (!this.queryPendingTask.projectId) {
                this.restartFilters()
                this.filterForm.secondValue = ''
                this.filterForm.secondValueNumber = ''
                this.filterForm.secondValueSelect = ''
                this.filterForm.thirdValueSelect = []
                this.filterForm.filterDatePickerValue = []
                this.filterForm.secondValueSelectMultiple = []
                this.$notify({
                  title: this.$t('pendingtask.pendingtask_detail.notify.selected_service'),
                  type: 'warning',
                  position: 'top-right',
                  customClass: 'b2b-notification-error',
                  duration: 10000
                })
                return
              }
            }

            this.selectedFilters = this.listSelectedFiltersPendingTask
            this.selected.selected = true
            this.selectedFilters.push(this.selected)
            await this.listSelectedFiltersPendingTaskState(
              this.selectedFilters
            )

            this.selected = {}
            this.$refs[formName].resetFields()
            this.filterForm.filterDatePickerValue = []

            this.queryPendingTask.page = 0
            await this.queryPendingTaskState(this.queryPendingTask)
            dataQuery.query = this.queryPendingTask

            const response = await this.getPendingTask(dataQuery)
            this.totalResults = response.data.totalElements
          } catch (error) {
            load.close()
            console.log('onSubmit FILTER CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.handleDeleteAllFilters('backerror')
          } finally {
            load.close()
            this.initForm()
          }
        } else {
          console.log('error submit!!')
        }
      })
    },

    async getDateTimePickerValue () {
      if (!this.dateTimePickerValue) {
        this.dateTimePickerValue = []
        this.dateTimePickerValue.push(this.queryPendingTask.creationDateTimeFrom)
        this.dateTimePickerValue.push(this.queryPendingTask.creationDateTimeTo)
      } else {
        this.queryPendingTask.creationDateTimeFrom = this.dateTimePickerValue[0]
        this.queryPendingTask.creationDateTimeTo = this.dateTimePickerValue[1]
        // Si el usuario logeado tiene mas de un proyecto no seleccionamos servicio no hacemos nada
        if (this.optionsFilterService.length > 1) {
          if (!this.queryPendingTask.projectId) {
            return
          }
        }
        const dataQuery = {
          query: {}
        }
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.filter_date')
        })
        try {
          await this.queryPendingTaskState(this.queryPendingTask)
          dataQuery.query = this.queryPendingTask
          const response = await this.getPendingTask(dataQuery)
          this.totalResults = response.data.totalElements
        } catch (error) {
          console.log('onSubmit FILTER CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },
    async refreshResults () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        await this.queryPendingTaskState(this.queryPendingTask)
        dataQuery.query = this.queryPendingTask
        const response = await this.getPendingTask(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('onSubmit FILTER CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    getFirstRangeDate () {
      const start = new Date()
      const end = new Date()
      // Si es superadmin 30 dias de lo contrario 90 dias
      if (this.activeUser.data.isSuperAdmin) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      } else {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      }
      this.dateTimePickerValue.push(start)
      this.dateTimePickerValue.push(end)
    },

    async handleDeleteAllFilters (val) {
      // Reseteamos estados
      if (this.optionsFilterService.length > 1) {
        await this.optionsFilterStatusPendingTaskState([])
      }

      this.selectedFilters = []
      const dataQuery = {
        query: {}
      }
      let load = {}
      console.log(val)
      if (val !== 'backerror') {
        load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.filter_delete_all')
        })
      }
      try {
        // Reseteamos la prop selected de los filtros
        this.resetSelectedOptions(this.options)
        await this.listSelectedFiltersPendingTaskState([])
        this.selectedFilters = this.listSelectedFiltersPendingTask.map(item => {
          item.labelText = ''
          item.query = ''
          item.selected = false
          return item
        })
        await this.listSelectedFiltersPendingTaskState(this.selectedFilters)

        if (!this.dateTimePickerValue) {
          this.queryPendingTask.creationDateTimeFrom = ''
          this.queryPendingTask.creationDateTimeTo = ''
        } else {
          this.queryPendingTask.creationDateTimeFrom = this.dateTimePickerValue[0]
          this.queryPendingTask.creationDateTimeTo = this.dateTimePickerValue[1]
        }

        // Solo si el usuario es superadmin reseteamos el proyecto
        if (this.activeUser.data.isSuperAdmin) {
          this.queryPendingTask.projectId = ''
        }
        this.queryPendingTask.buyerId = ''
        this.queryPendingTask.sellerId = ''
        this.queryPendingTask.invoiceNumber = ''
        this.queryPendingTask.invoiceSeriesCode = ''
        this.queryPendingTask.correctiveInvoiceNumber = ''
        this.queryPendingTask.totalExecutableAmountFrom = ''
        this.queryPendingTask.totalExecutableAmountTo = ''
        this.queryPendingTask.statusId = ''
        this.queryPendingTask.documentClassCode = ''
        this.queryPendingTask.registerNumber = ''
        this.queryPendingTask.receptionMethodId = ''
        this.queryPendingTask.withAttachment = ''
        this.queryPendingTask.statusInternalId = ''
        this.queryPendingTask.pendingTask = ''
        this.queryPendingTask.invoiceTypeId = ''
        this.queryPendingTask.taxTypeCode = ''
        this.queryPendingTask.rate = ''
        this.queryPendingTask.currencyId = ''
        this.queryPendingTask.orderNumber = ''
        this.queryPendingTask.contract = ''
        this.queryPendingTask.deliveryNote = ''
        this.queryPendingTask.file = ''
        this.queryPendingTask.issueDateFrom = ''
        this.queryPendingTask.issueDateTo = ''
        this.queryPendingTask.operationDateFrom = ''
        this.queryPendingTask.operationDateTo = ''
        this.queryPendingTask.buyerGenericCentreId = ''
        this.queryPendingTask.sellerCentreId = ''

        await this.queryPendingTaskState(this.queryPendingTask)
        dataQuery.query = this.queryPendingTask
        await this.getPendingTask(dataQuery)
      } catch (error) {
        console.log('getUsers CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        this.initForm()
        if (val !== 'backerror') {
          load.close()
        }
      }
    },
    async getBuyerResults (data) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      const requestParty = {
        role: 'BUYER',
        enable: true,
        emission: false,
        seller: false,
        projectId: [this.queryPendingTask.projectId],
        page: 0,
        size: 1000,
        tradeNameOrTaxId: data
      }
      try {
        const response = await this.getOptionsFilterPartyMEFenixBackend(requestParty)
        this.selected.options = response
        this.auxListPartiesBuyer = response
        this.optionsFilterBuyerPendingTaskState(response)
      } catch (error) {
        console.log('filterPartiesBuyer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async filterPartiesBuyer (data) {
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getBuyerResults, 1000, data)
        // Si el valor introducido tiene más de 3 caracteres, se filtra en la propia lista obtenida anteriormente
        } else {
          this.auxListPartiesBuyer = []
          this.optionsFilterBuyerPendingTaskState(this.auxListPartiesBuyer)
        }
      } catch (error) {
        console.log('filterPartiesBuyer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async getSellerResults (data) {
      const load = this.$loading({
        lock: true
      })
      const requestParty = {
        role: 'SELLER',
        enable: true,
        emission: false,
        seller: true,
        projectId: this.queryPendingTask.projectId,
        page: 0,
        size: 1000,
        tradeNameOrTaxId: data
      }
      try {
        const response = await this.getOptionsFilterPartyMEFenixBackend(requestParty)
        this.selected.options = response
        this.auxListPartiesSeller = response
        this.optionsFilterSellerPendingTaskState(response)
      } catch (error) {
        console.log('filterPartiesBuyer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async filterPartiesSeller (data) {
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getSellerResults, 1000, data)
        // Si el valor introducido tiene más de 3 caracteres, se filtra en la propia lista obtenida anteriormente
        } else {
          this.auxListPartiesSeller = []
          this.optionsFilterSellerPendingTaskState(this.auxListPartiesSeller)
        }
      } catch (error) {
        console.log('filterPartiesSeller CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    // Metodo lanzado al capturar el evento de closeTag
    async resetSelectedOneOption (data) {
      this.resetOneOption(this.options, data.filter)
      await this.listSelectedFiltersPendingTaskState(data.listAfterRemove)
      this.initForm()
    },

    initForm () {
      if (!this.options.num_factura.selected) {
        this.filterForm.firstValue = this.options.num_factura
        this.selected = this.filterForm.firstValue
      } else {
        this.filterForm.firstValue = ''
        this.selected = this.filterForm.firstValue
      }
    },

    async changeStatus (projectId) {
      // Filtramos los estados por proyecto
      try {
        await this.getOptionsFilterStatusPendingTask(projectId)
      } catch (error) {
        console.log('getOptionsFilterStatusPendingTask CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    restartFilters () {
      this.queryPendingTask.projectId = ''
      this.queryPendingTask.buyerId = ''
      this.queryPendingTask.sellerId = ''
      this.queryPendingTask.invoiceNumber = ''
      this.queryPendingTask.invoiceSeriesCode = ''
      this.queryPendingTask.correctiveInvoiceNumber = ''
      this.queryPendingTask.totalExecutableAmountFrom = ''
      this.queryPendingTask.totalExecutableAmountTo = ''
      this.queryPendingTask.statusId = ''
      this.queryPendingTask.documentClassCode = ''
      this.queryPendingTask.registerNumber = ''
      this.queryPendingTask.receptionMethodId = ''
      this.queryPendingTask.withAttachment = ''
      this.queryPendingTask.statusInternalId = ''
      this.queryPendingTask.pendingTask = ''
      this.queryPendingTask.invoiceTypeId = ''
      this.queryPendingTask.taxTypeCode = ''
      this.queryPendingTask.rate = ''
      this.queryPendingTask.currencyId = ''
      this.queryPendingTask.orderNumber = ''
      this.queryPendingTask.contract = ''
      this.queryPendingTask.deliveryNote = ''
      this.queryPendingTask.file = ''
      this.queryPendingTask.issueDateFrom = ''
      this.queryPendingTask.issueDateTo = ''
      this.queryPendingTask.operationDateFrom = ''
      this.queryPendingTask.operationDateTo = ''
      this.queryPendingTask.buyerGenericCentreId = ''
      this.queryPendingTask.sellerCentreId = ''
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$i18n.messages.es.error.e500
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    // Creamos una copia del json que contiene los datos de los filtros y trabajamos con la copia
    this.options = JSON.parse(JSON.stringify(this.filterOptions))

    // Ponemos el estado de selected a true si ya estaba seleccionado el filtro
    this.checkListFilterSelected(this.options, this.listSelectedFiltersPendingTask)

    // Si el usuario sólo tiene un servicio, quitamos el filtro de servicios y añadimos el servicio a la consulta
    if (this.activeUser.data.projects && this.activeUser.data.projects.length < 2) {
      delete this.options.servicio
    }
    this.getProjectPartiesCentres()
    this.initForm()
    if (this.queryPendingTask.creationDateTimeFrom) {
      this.dateTimePickerValue.push(this.queryPendingTask.creationDateTimeFrom)
      this.dateTimePickerValue.push(this.queryPendingTask.creationDateTimeTo)
    }
    try {
      await this.queryPendingTaskState(this.queryPendingTask)
      // Unicamente si tiene 1 solo proyecto el usuario logeado
      if (this.optionsFilterService.length < 2) {
        await this.getOptionsFilterStatusPendingTask(this.queryPendingTask.projectId)
        const dataQuery = {
          query: {}
        }

        dataQuery.query = this.queryPendingTask
        const response = await this.getPendingTask(dataQuery)
        this.totalResults = response.data.totalElements
      }
      // Estados internos
      await this.getOptionsFilterStatusInternalPendingTask()
      // Agregamos sin estado a combo de estados internos
      const sinestado = {
        id: -2,
        code: this.$t('WITHOUT_INTERNAL_STATUS')
      }
      this.optionsFilterInternalStatusPendingTask.push(sinestado)
      this.optionsFilterInternalStatusPendingTaskState(this.optionsFilterInternalStatusPendingTask)
      await this.getOptionsFilterInvoiceReceiveMethods()
    } catch (error) {
      this.getNotificationErrorMessage(error)
    }
  },

  updated () {
    if (this.optionsFilterService.length > 1) {
      this.options.servicio.options = this.optionsFilterService
    }
    this.options.comprador.options = this.optionsFilterBuyerPendingTask
    this.options.vendedor.options = this.optionsFilterSellerPendingTask
    this.options.divisa.options = this.optionsFilterCurrency
    this.options.clase.options = this.optionsFilterInvoiceClasses
    this.options.tipo_impuesto.options = this.optionsFilterInvoiceTaxType
    this.options.tipo_factura.options = this.optionsFilterInvoiceType
    this.options.estado.options = this.optionsFilterStatusPendingTask
    this.options.estado_interno.options = this.optionsFilterInternalStatusPendingTask
    this.options.recepcion.options = this.optionsFilterInvoiceReceiveMethods
  }
}
</script>

<style lang="scss" scoped>

// BMG Tags centered into the status input into the container
::v-deep .ods-select__tags {
  margin-top: rem(20) !important;
}
::v-deep .b2b-filters__area .ods-form-item input {
  margin-bottom: rem(20) !important;
  height: 32px !important;
}
::v-deep .ods-select .ods-input.is-focus .ods-input__inner {
  height: 32px !important;
}
::v-deep .ods-input__prefix {
  height: 72px !important;
}
::v-deep .ods-input__suffix {
  height: 72px !important;
}
//
.b2b-filters{
  ::v-deep .ods-tag--secondary {
    background-color: var(--color-bg-hover-2) !important;
    border-color: transparent !important;
    color: var(--color-bg-interactive) !important;
}
::v-deep .ods-icon-close, body .ods-icon-close {
    border-radius: 50%;
    text-align: center;
    position: relative;
    cursor: pointer;
    font-size: 12px !important;
    height: 8px;
    width: 8px;
    line-height: 1;
    vertical-align: middle;
    right: -1px;
    top: -3px;
    color: var(--color-bg-interactive);
}
::v-deep .ods-tag {
    display: inline-block;
    padding: 4px 16px;
    height: 24px;
    line-height: 14px;
    font-size: 9px;
    color: #fff;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    white-space: nowrap;
    text-transform: uppercase;
    font-family: soho,Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,"\5FAE\8F6F\96C5\9ED1",Arial,sans-serif;
    font-weight: 600;
    letter-spacing: .2px;
    border: 1px solid;
}
  .b2b-filters__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;
    background-color: white;
  }
  // background-color: var(--color-bg-primary);
  // border-top: .1rem solid $grey-2;
  // box-shadow: 0 .2rem .8rem 0 rgba(0, 0, 0, 0.08);

  .dateHeader {
    font-size: 12px;
    padding: 0 28px 0 20px;
    color: var(--color-txt-secondary);
  }

  .ods-button{
    display: inline;
  }

  ::v-deep &__area {
    display: flex;

    .ods-form-item {
      margin-bottom: 0;
      &__content {
        line-height: inherit;
      }
      &__error {
        top: rem(55);
      }
      input {
        max-width: rem(200);
      }
      select {
        max-width: rem(200);
      }
    }

    .first-input {
      margin-right: rem(32);
    }

    // Para los input que no sean datepicker,
    // colocar un margen igual a como si tuviese el botón del datepicker
    .others-input {
      margin-right: rem(16);
    }

    .ods-form-item__label {
      display: none
    }

    .ods-range-separator {
      padding: 0 rem(8);
    }
  }

  &__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;

    .clean-filters {
      color: var(--color-status-info-400);
      .ods-icon-delete {
        margin-left: 0px;
      }
    }
  }

  &__button {
    margin: 0 0 0 1.25rem;
    display: inline-block;
    width: auto;
  }
  ::v-deep .ods-select .ods-tag {
    margin: 2px 0 -52px 6px;
  }
  ::v-deep .b2b-search-bar__header-right {
    margin-right: 2.5rem;
  }
}
</style>
